import { useEffect, useState } from "react";
import { FINANCIAL_CAREGIVER_FEATURE_FLAG_V4 } from "../../../Utils/constants";
import { isCaregiverPermission } from "../../../Utils";

// Loads the financial caregiver permissions for the logged-in guardian and the given senior,
// and returns a checker: hasPermission('Finance.Accounts.Banking') => true / false.
// Anything not explicitly disabled by the API is treated as allowed.
export const useCaregiverPermissions = (props, wardId) => {
  const guardianId = props?.state?.user?.self?.userId;
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (!guardianId || !wardId) {
      return;
    }
    // Clear the previous senior's permissions until the new ones load
    setPermissions([]);
    props._list(FINANCIAL_CAREGIVER_FEATURE_FLAG_V4(guardianId, wardId), null, (res) => {
      setPermissions(res?.permissions || []);
    }, err => {
      setPermissions([]);
    });
  }, [guardianId, wardId]);

  return (featureName) => isCaregiverPermission(permissions, featureName);
};
